<script setup lang="ts">
import { LocalModelType } from "@/features/BuildingProject";
import SharedModelCard from "../../Shared/ModelCard.vue";

const props = defineProps<{
  model: LocalModelType;
}>();

// The parent owns the model list and flips isActive; mutating the prop here would hide the edit from it.
const emit = defineEmits<{
  toggle: [model: LocalModelType];
}>();
</script>

<template>
  <SharedModelCard
    :model="props.model"
    @toggle="emit('toggle', props.model)" />
</template>
